import { RootState } from "store/store";

export const selectRouteResponse = (state: RootState) =>
  state.routeResponse.data;
